import { useFormik } from 'formik';
import React, { useEffect } from 'react'
import { useState } from 'react';
import CustomTextField from '../../../../../components/custom_text_field/CustomTextField';
import { get_status } from '../../../../../api/statusApis';
import { get_roles_with_out_pagination } from '../../../../../api/rolesApis';
import CustomAutoCompleteDropdown from '../../../../../components/custom_auto_complete_dropdown/CustomAutoCompleteDropdown';
import './PackagesFilterStyles.css'
import { get_locations_with_out_pagination } from '../../../../../api/locationApis';
import { get_hotel_lists_with_pagination, get_hotels } from '../../../../../api/hotelApis';
import { get_services, get_services_list } from '../../../../../api/servicesApis';
import { get_client_lists_without_pagination } from '../../../../../api/clientApis';
import { RiFilterFill } from "react-icons/ri";
import dayjs from "dayjs";
import CustomDatePicker from '../../../../../components/custom_date_picker/CustomDatePicker';
import { get_ecr_status, get_package_status, get_ticket_type } from '../../../../../api/commonLookUpApis';
import { useDispatch, useSelector } from 'react-redux';
import { resetNotificationRedirect } from '../../../../../store/commonStore';

function PackagesFilter({ searchFilter }) {
    const filter_data_store = useSelector((state) => state.commonStore.notification_redirect)
    const dispatch = useDispatch()
    const [role, setRole] = useState([])
    const [state, setStatus] = useState([])
    const [locations, setlocation] = useState([])

    const [client, setClient] = useState([])
    const [hotels, setHotels] = useState([])
    const [servicesList, setServicesList] = useState([])

    const [advanceFilter, setAdvanceFilter] = useState(false)
    const [ecrStatus, setEcrStatus] = useState([])
    const [ticketType, setTicketType] = useState([])


    const getEcrStatus = () => {
        get_package_status().then((response) => {
            const data = response?.data?.data?.map((item) => {
                return {
                    label: item.ESL_name,
                    value: item.ESL_id,
                };
            });
            setEcrStatus(data)
        }).catch((error) => {
            console.log(error)
        })
    }
    const getTicketTypeList = () => {
        get_ticket_type().then((response) => {
            const data = response?.data?.data?.map((item) => {
                return {
                    label: item.TT_type,
                    value: item.TT_id,
                };
            });
            setTicketType(data)
        }).catch((error) => {
            console.log(error)
        })
    }
    const getHotels = () => {
        get_hotel_lists_with_pagination().then((response) => {
            const data = response?.data?.data?.data.map((item) => {
                return {
                    label: item.hotelName,
                    value: item.hotel_id,
                };
            });
            setHotels(data)
        }).catch((error) => {
            console.log(error)
        })
    }
    const getServices = () => {
        get_services_list().then((response) => {
            const data = response?.data?.data?.map((item) => {
                return {
                    label: item.ES_services_name,
                    value: item.ES_id,
                };
            });
            setServicesList(data)
        }).catch((error) => {
            console.log(error)
        })
    }
    const getClientList = () => {
        get_client_lists_without_pagination().then((response) => {
            const data = response?.data?.map((item) => {
                return {
                    label: item.CI_name,
                    value: item.CI_id,
                };
            });
            setClient(data)
        }).catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        getHotels()
        // getServices()
        getEcrStatus()
        getClientList()
        getTicketTypeList()
        if (filter_data_store?.filter_data) {
            formik.setValues({ ...formik.values, 'filename': filter_data_store?.filter_data })
            searchFilter({ ...formik.values, 'filename': filter_data_store?.filter_data })
        } else {
            searchFilter({ ...formik.values, 'filename': "" })
        }
    }, [])



    const formik = useFormik({
        initialValues: {
            'filename': '',
            "hotel": '',
            "date": "",
            'designation': '',
            'client': "",
            'start_date': '',
            'end_date': '',
            'status': '',
            'ticket_type': ''
        },
        onSubmit: (values) => {
            searchFilter(values)
        }
    });

    // const getStatus = () => {
    //     get_status().then((response) => {
    //         const data = response.map((item) => {
    //             return {
    //                 label: item.status_name,
    //                 value: item.id,
    //             };
    //         });
    //         setStatus(data)
    //     }).catch((error) => {
    //         console.log(error)
    //     })
    // }

    const resetFilter = () => {
        dispatch(resetNotificationRedirect())
        formik.setValues({
            ...formik.values, ...{
                'filename': '',
                "hotel": '',
                "date": "",
                'designation': '',
                'client': "",
                'start_date': '',
                'end_date': '',
                'status': '',
                'ticket_type': ''
            }
        })
    }


    return (
        <div className='users_filter_main_container'>
            <form id="packagesFilterForm" onSubmit={formik.handleSubmit}>
                <div className='package_filter_sub_container'>
                    <div>
                        <CustomTextField
                            name="filename"
                            placeholder={"Enter file name"}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.filename}
                        />
                    </div>

                    {/* <div>
                        <CustomTextField
                            name="designation"
                            placeholder={"Enter Designation"}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.designation}
                        />
                    </div> */}

                    <div >
                        <CustomAutoCompleteDropdown
                            name="ticket_type"
                            placeholder={"Select a ticket type"}
                            options={ticketType}
                            onChange={(event, newValue) => {
                                formik.setFieldValue(
                                    "ticket_type",
                                    newValue ? newValue.value : ""
                                );
                            }}
                            onBlur={formik.handleBlur}
                            value={
                                ticketType.find((type) =>
                                    type.value ===
                                    formik.values.ticket_type
                                ) || null
                            }
                        />
                    </div>


                    <div>
                        <CustomAutoCompleteDropdown
                            name="hotel"
                            placeholder={"Select a hotel "}
                            options={hotels}
                            onChange={(event, newValue) => {
                                formik.setFieldValue(
                                    "hotel",
                                    newValue ? newValue.value : ""
                                );
                            }}
                            onBlur={formik.handleBlur}
                            value={
                                hotels.find((type) =>
                                    type.value ===
                                    formik.values.hotel
                                ) || null
                            }
                        />
                    </div>

                    <div>
                        <CustomAutoCompleteDropdown
                            name="client"
                            placeholder={"Select a client"}
                            options={client}
                            onChange={(event, newValue) => {
                                formik.setFieldValue(
                                    "client",
                                    newValue ? newValue.value : ""
                                );
                            }}
                            onBlur={formik.handleBlur}
                            value={
                                client.find((type) =>
                                    type.value ===
                                    formik.values.client
                                ) || null
                            }

                        />
                    </div>


                    <div>
                        <CustomAutoCompleteDropdown
                            name="status"
                            placeholder={"Select a status"}
                            options={ecrStatus}
                            onChange={(event, newValue) => {
                                formik.setFieldValue(
                                    "status",
                                    newValue ? newValue.value : ""
                                );
                            }}
                            onBlur={formik.handleBlur}
                            value={
                                ecrStatus.find((type) =>
                                    type.value ===
                                    formik.values.status
                                ) || null
                            }
                        />
                    </div>

                    <div className='user_filter_actions'>
                        <button className='user_filter_action_reset' onClick={() => {
                            resetFilter()
                        }}>Reset</button>
                        <button className='user_filter_action_search'
                            type="submit"
                            form="packagesFilterForm"
                        >Search</button>
                        <div>
                            <RiFilterFill className='filter_action_icons' onClick={() => {
                                setAdvanceFilter(!advanceFilter)
                            }} />
                        </div>
                    </div>

                </div>
                {advanceFilter && (
                    <>
                        <div className='flight_ticket_filter_sub_container'>
                            <div>
                                <CustomTextField
                                    name="designation"
                                    placeholder={"Enter Designation"}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.designation}
                                />
                            </div>
                            {/* <div className='flight_ticket_filter_style_1'>
                                <CustomAutoCompleteDropdown
                                    name="service"
                                    placeholder={"Select a service"}
                                    options={servicesList}
                                    onChange={(event, newValue) => {
                                        formik.setFieldValue(
                                            "service",
                                            newValue ? newValue.value : ""
                                        );
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={
                                        servicesList.find((status) =>
                                            status.value ===
                                            formik.values.service
                                        ) || null
                                    }
                                />
                            </div> */}

                            <div className='flight_ticket_filter_sub_date_selection_container'>
                                <div className='flight_ticket_filter_style_1'>
                                    <p className='flight_ticket_filter_legent_style_1'>Issue start to end date</p>
                                    <CustomDatePicker
                                        no_border
                                        name="start_date"
                                        onChange={(date) => {
                                            formik.setFieldValue("start_date", date);
                                        }}
                                        onBlur={formik.handleBlur}
                                        value={dayjs(formik.values.start_date, "DD-MM-YYYY")}
                                        error={
                                            formik.touched.start_date &&
                                            Boolean(formik.errors.start_date)
                                        }
                                        helperText={
                                            formik.touched.start_date && formik.errors.start_date
                                        } />
                                </div>
                                <div>
                                    <p>--</p>
                                </div>
                                <div className='flight_ticket_filter_style_1'>
                                    {/* <p className='flight_ticket_filter_legent_style_2'>End date</p> */}
                                    <CustomDatePicker
                                        no_border
                                        disabled={formik.values.start_date ? false : true}
                                        minDate={dayjs(formik.values.start_date, "DD-MM-YYYY")}
                                        name="end_date"
                                        onChange={(date) => {
                                            formik.setFieldValue("end_date", date);
                                        }}
                                        onBlur={formik.handleBlur}
                                        value={dayjs(formik.values.end_date, "DD-MM-YYYY")}
                                        error={
                                            formik.touched.end_date &&
                                            Boolean(formik.errors.end_date)
                                        }
                                        helperText={
                                            formik.touched.end_date && formik.errors.end_date
                                        } />
                                </div>
                            </div>
                        </div>

                    </>
                )}


            </form>
        </div>
    )
}

export default PackagesFilter